import { useDispatch } from 'react-redux';
import { Box, TextField } from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import RegularButton from "components/CustomButtons/Button";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { setDelCause } from "redux/actions/routesStatus/routesStatusAction";
import { removeSettlementNote } from 'redux/actions/routesStatus/routesStatusAction';
import { useSearch } from 'hooks/useSearch';
import { validateObject } from 'helpers/validateObject';

export const DelCauses = ({note, onClose, notes=[]}) => {
  const { causes } = useSelector(({routesStatus}) => routesStatus);
  const dispatch = useDispatch();
  const [cause, setCause] = useState(causes[0] || null); 
  const { setSnackbar } = useSearch();

  const handleCause = (v) => {
    setCause(v);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!cause) return setSnackbar('No se registró una causa válida', 'warning');
    if(notes.length > 0) {
      const nNotes = notes.filter((nt) => !nt.isNew);
      nNotes.forEach((nt) => {
        dispatch(removeSettlementNote(nt.id, cause.id));
      });
    } else {
      dispatch(removeSettlementNote(note.id, cause.id));
    }
    onClose();
  };

  const handleRestore = () => {
    dispatch(setDelCause(note.id, null));
    onClose();
  };

  useEffect(() => {
    if (validateObject(note) && note.deleted) {
      const idx = causes.findIndex(c => c.id === note.deletedCauseId);
      if (idx !== -1) setCause(causes[idx]);
    }
  }, [note?.deleted, causes]);

  return (
    <form onSubmit={handleSubmit} style={{widht: '100%'}}>
      <Autocomplete
        id="settlement-causes-select"
        options={causes}
        value={cause || null} 
        getOptionLabel={(option) => option?.label || ""} 
        renderInput={(params) => (
          <TextField
            {...params}
            label="Seleccione Causa de Cancelación"
            variant="outlined"
            size="small"
            fullWidth
          />
        )}
        onChange={(e, v) => handleCause(v)}
        noOptionsText="No hay opciones disponibles"
        popupIcon={false}
      />
      <Box style={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 16,
        gap: 8
      }}>
        <RegularButton color="transparent" onClick={onClose}>
          Cancelar
        </RegularButton>
        <RegularButton color="info" onClick={handleSubmit} disabled={!cause || cause === null}>
          Guardar
        </RegularButton>
      </Box>
    </form>
  );
};

